// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"281":"2c87b7fc","342":"98ffeffb","665":"35c52ac4","715":"d4cce71b"}[chunkId] + ".chunk.js";
};